var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pb-6"},[_c('atom-spinner',{staticClass:"m-auto",attrs:{"animation-duration":1000,"size":80,"color":'#553F77'}}),_c('p',{staticClass:"has-text-centered has-text-primary"},[_vm._v(" Loading... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }